import { Role } from '@app/core/interfaces/c5/role';

export enum SecurityRoleLevel {
  END_USER = 'END_USER',
  ENTERPRISE_ADMIN = 'ENTERPRISE_ADMIN',
  SERVICE_PROVIDER_ADMIN = 'SERVICE_PROVIDER_ADMIN',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
}

export const SecurityRoleLevelToRoleMapping = {
  [SecurityRoleLevel.END_USER]: Role.END_USER,
  [SecurityRoleLevel.ENTERPRISE_ADMIN]: Role.ENTERPRISE_ADMIN,
  [SecurityRoleLevel.SERVICE_PROVIDER_ADMIN]: Role.SERVICE_PROVIDER_ADMIN,
  [SecurityRoleLevel.SYSTEM_ADMIN]: Role.SYSTEM_ADMIN,
};
